import * as React from 'react';
import { Position } from '@westwing/ui-kit/Picture/Image';
import Price, { usePrice } from './Price';
import * as Styled from './OldHero.styles';
import CTAButton, { useCTAButtonTracking } from '@ids/components/CTAButton';
import Divider from '@ids/components/Layout/Divider';
import { useHeroBlock } from '@ids/context/LandingPage';
import Skeleton from '@ids/components/Layout/Skeleton';

const OldHero = () => {
    const heroBlock = useHeroBlock();
    const trackCTAButtonClick = useCTAButtonTracking();
    const price = usePrice(heroBlock?.promotionalPrice, heroBlock?.price);

    if (!heroBlock) {
        return <Skeleton />;
    }

    return (
        <React.Fragment>
            <Styled.HeroSection data-testid="hero-block-section" id="hero-block">
                <Styled.Banner>
                    <Styled.HeadlineText>{heroBlock.headline}</Styled.HeadlineText>
                    <Styled.Title as="h1">{heroBlock.title}</Styled.Title>
                    <Price>{price}</Price>
                    <CTAButton data-testid="hero-cta-button" onClick={() => trackCTAButtonClick('ga_hero_cta')}>
                        {heroBlock.ctaText}
                    </CTAButton>
                </Styled.Banner>
                <Styled.Media
                    priority
                    $desktopOnly
                    media={heroBlock.media.desktop}
                    image={{ layout: 'fill', objectPosition: [Position.CENTER, Position.BOTTOM] }}
                />
                <Styled.Media
                    priority
                    $mobileOnly
                    media={heroBlock.media.mobile}
                    image={{ layout: 'fill', objectPosition: [Position.CENTER, Position.BOTTOM] }}
                />
                <Styled.SubtitleText as="h2">{heroBlock.contentText}</Styled.SubtitleText>
            </Styled.HeroSection>
            <Divider />
        </React.Fragment>
    );
};

export default OldHero;
